/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * GeopolView class.
 *
 * @class GeopolView
 * @module Models
 */
define(['./geopolViewsMapping'], function(geopolViewsMapping) {
    'use strict';

    var validServiceTypes = ['search', 'maps', 'reverseGeocoder'];

    function isValidServiceType(serviceType) {
        return validServiceTypes.indexOf(serviceType) > -1;
    }

    /**
     * @ignore
     * @param {String} geopolCode
     */
    function GeopolView(geopolCode) {
        if (!geopolViewsMapping.hasOwnProperty(geopolCode)) {
            geopolCode = 'Unified';
            console.warn('Incorrect geopolitical view code passed to GeopolViewService.',
                'Defaulting to "' + geopolCode + '".');
        }
        this.code = geopolCode;
    }

    /**
     * Returns the code of the geopolitical view.
     * @method getCode
     * @return {String}
     */
    GeopolView.prototype.getCode = function() {
        return this.code;
    };

    /**
     * Returns the label of the geopolitical view.
     * @method getLabel
     * @return {String}
     */
    GeopolView.prototype.getLabel = function() {
        return geopolViewsMapping[this.code].label;
    };

    /**
     * Returns the geopolitical view code for the given service type.
     *
     * @method getValueFor
     * @param {"search"|"maps"} [serviceType] The service code.
     *  But we aware of these cases:
     *  - If serviceType is not supported undefined will be returned;
     *  - If no value is given it will return the same value as the method
     *    {{#crossLink "GeopolView/getCode:method"}}{{/crossLink}}.
     *  - If a view is not supported for the given service it may fallback to Unified.
     * @param {"raster"|"vector"} [subType] Used to specify the subType of a service,
     * for example 'maps - raster' (Only available for maps);
     * @return {String}
     */
    GeopolView.prototype.getValueFor = function(serviceType, subType) {
        var fallbackValue, serviceMapping;
        if (!serviceType) {
            return this.code;
        }
        if (!isValidServiceType(serviceType)) {
            console.warn('Unsupported service type passed to getValueFor function in geopolView. ' +
                'Expecting: ' + validServiceTypes.join(', ') + '. Returning undefined.');
            return undefined;
        }

        if ((serviceType !== 'maps' && subType) ||
            (serviceType === 'maps' && ['raster', 'vector'].indexOf(subType) === -1)) {
            console.warn('Please specify a valid subType for this service. ' +
                'Expecting: raster or vector. Returning undefined.');
            return undefined;
        }

        serviceMapping = geopolViewsMapping[this.code][serviceType];

        if (serviceMapping && subType) {
            serviceMapping = serviceMapping[subType];
        }

        if (serviceMapping && serviceMapping.fallback) {
            fallbackValue = serviceMapping.fallback;
            console.warn(this.code + ' is not supported by the service "' + serviceType +
            (subType ? ' - ' + subType : '') + '". Falling back to ' + fallbackValue + '.');
            return fallbackValue;
        }

        return this.code;
    };

    /**
     * Returns supported service types by geopolView
     *
     * @method getSupportedServices
     * @return {Array}
     */
    GeopolView.getSupportedServices = function() {
        return validServiceTypes;
    };

    Object.defineProperty(GeopolView.prototype, 'toString', {
        enumerable: false,
        value: function() {
            return this.getCode();
        }
    });

    return GeopolView;
});



// WEBPACK FOOTER //
// ./config/geopolView/geopolView.js